import { useMemo } from 'react';
import { DashBoardValue } from 'features/dashBoard/hooks';
import { DashBoardItemOption } from 'features/dashBoard/types';
import { GraphOptions, getAxisDef, getValueDef } from '../../common'

import {
  Sort as SortIcon,
  Functions as TotalIcon
 } from '@mui/icons-material';

 import { TargetListResult } from "interface/search/targetList"

 export const PieGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis',
      type: 'axis',
      label: '軸',
      suffix: 'ごとの'
    },
    {
      id: 'value',
      type: 'value',
      label: '値'
    }
  ], [
    {
      id: 'sort',
      type: 'check',
      label: '並び替え',
      default: 'false',
      toolBtn: <SortIcon fontSize="small"/>
    },
    {
      id: 'total',
      type: 'check',
      label: '全体',
      default: 'false',
      fromSubSource: true,
      toolBtn: <TotalIcon fontSize="small"/>
    }
  ]
]
type usePieGraphOptionProps<T> = {
  dashBoard: DashBoardValue<T>
  options?: DashBoardItemOption[]
  targetList?: TargetListResult
}
export const usePieGraphOption = <T,>({
  dashBoard: {
    configure,
    globalAxisKey
  },
  options,
  targetList
}: usePieGraphOptionProps<T>) => useMemo(
  () => ({
    configure, options, targetList,
		axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
		valueDef: getValueDef(configure, options, 'value', targetList),
		sort: options?.find((opt) => opt.id === 'sort')?.value === 'true',
    total: options?.find((opt) => opt.id === 'total')?.value === 'true'
}),
  [options, configure, globalAxisKey, targetList]
)
